import React, { useEffect, useState } from "react";
import Footer from "../components/Footer";
import Header from "../components/Header";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./Home";
import Account from "./Account";
import Cart from "./Cart";
import Admin from "./Admin";
import Product from "./Product";
import Checkout from "./Checkout";
import Orders from "./Orders";
import UserAccount from "./UserAccount";
import { useDispatch, useSelector } from "react-redux";
import withSessionTimeout from "../HOCS/withSessionTimeout";
import { authenticated } from "../actions/adminActions";
import Profile from "../components/UserAccount/Profile";
import Chatlist from "./Chatlist";
import { SocketContextProvider } from "../context/SocketContext";
import NotFound from "./NotFound";
const WithSessionTimeoutHome = withSessionTimeout(Home);
const WithSessionTimeoutOrder = withSessionTimeout(Orders);
const WithSessionTimeoutCart = withSessionTimeout(Cart);
const WithSessionTimeoutAdmin = withSessionTimeout(Admin);
const WithSessionTimeoutProduct = withSessionTimeout(Product);
const WithSessionTimeoutCheckout = withSessionTimeout(Checkout);
const WithSessionTimeoutUserAccount = withSessionTimeout(UserAccount);
const WithSessionTimeoutAccount = withSessionTimeout(Account);
const WithSessionTimeoutChatlist = withSessionTimeout(Chatlist);

const Mainpage = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    (async function getAuthenticated() {
      const { id } = await authenticated();

      dispatch({ type: "USER_LOGGED_IN", payload: id });
    })();
  }, []);
  return (
    <>
      <SocketContextProvider>
        <div className="container">
          <Router>
            <div className="header-container">
              <Header />
            </div>
            <div className="body-container">
              <Routes>
                <Route path="/" element={<WithSessionTimeoutHome />} />
                <Route
                  exact
                  path="/login"
                  element={<WithSessionTimeoutAccount />}
                />
                <Route
                  exact
                  path="/cart"
                  element={<WithSessionTimeoutCart />}
                />
                <Route
                  exact
                  path="/admin"
                  element={<WithSessionTimeoutAdmin />}
                />
                <Route
                  exact
                  path="/product/:id"
                  element={<WithSessionTimeoutProduct />}
                />
                <Route
                  exact
                  path="/cart/checkout/:id"
                  element={<WithSessionTimeoutCheckout />}
                />
                <Route
                  exact
                  path="/orders/"
                  element={<WithSessionTimeoutOrder />}
                />
                <Route
                  path="/user/*"
                  element={<WithSessionTimeoutUserAccount />}
                ></Route>
                <Route
                  path="/chat"
                  element={<WithSessionTimeoutChatlist />}
                ></Route>
                <Route path="*" element={<NotFound />}></Route>
              </Routes>
            </div>
            <div className="footer-container">
              <Footer />
            </div>
          </Router>
        </div>
      </SocketContextProvider>
    </>
  );
};

export default Mainpage;
